export default __webpack_public_path__ + "static/media/image55.48b0458b.png";